import './legacy/checkout-legacy.js';
import { registerQuantitySpin } from './components/QuantitySpin.js';
import { registerPrefetch } from './net/prefetcher.js';

registerQuantitySpin();
registerPrefetch();
